import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { VisualizarImagenPage } from './visualizar-imagen.page';

const routes: Routes = [
  {
    path: '',
    component: VisualizarImagenPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [VisualizarImagenPage]
})
export class VisualizarImagenPageModule {}
